// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XTTR","rootNoMargin":"styles_rootNoMargin__3u7-L"};